import type { Types } from '@fiverr-private/theme';
import { MAX_PERCENT, MIN_PERCENT } from './constants';
import type { ProgressLineProps } from './types';

/**
 * Gets a "safe" percent for progressbars.
 */
export const getProgressPercent = (percent: number) => {
    if (isNaN(percent) || percent <= MIN_PERCENT) return MIN_PERCENT;
    if (percent >= MAX_PERCENT) return MAX_PERCENT;
    return percent;
};

export const getProgressColors = ({
    progressColor,
    trackColor,
}: Pick<ProgressLineProps, 'progressColor' | 'trackColor'>): {
    progressBackgroundColor: Extract<Types.Color, 'grey_800' | 'grey_1200'>;
    trackBackgroundColor: Extract<Types.Color, 'white' | 'grey_300'>;
} => {
    const progressBackgroundColor = progressColor === 'paused' ? 'grey_800' : 'grey_1200';
    const trackBackgroundColor = trackColor === 'white' ? 'white' : 'grey_300';

    return {
        progressBackgroundColor,
        trackBackgroundColor,
    };
};
